"use strict";
/*
 * Created on 02 25 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ReleaseType_1 = require("../../release/model/ReleaseType");
/**
 * @author Jaroslav Sevcik
 */


var PriceStickersReportDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceStickersReportDTO, _DomainObject_1$Domai);

  /**
   * DTO used for price stickers report
   *
   * @param rePriceType a type of release the counted prices are from
   * @param priceListTypeId id of a type of price list the counted prices are from
   * @param priceCodeId id of a price code the counted prices are assigned to
   * @param currentYearRepricingCount a number of new product prices from 1.1. this year to current date
   * @param lastTenWeeksRepricingCount a number of new product prices in last ten weeks
   * @param currentWeekRepricingCount a number of new product prices this week
   * @param lastYearSameWeekRepricingCount a number of new product prices the same week last year
   * @param nextWeekRepricingCount a number of new product prices forecasted the for next week
   */
  function PriceStickersReportDTO(rePriceType, priceListTypeId, priceCodeId, currentYearRepricingCount, lastTenWeeksRepricingCount, currentWeekRepricingCount, lastYearSameWeekRepricingCount, nextWeekRepricingCount) {
    var _this;

    _classCallCheck(this, PriceStickersReportDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceStickersReportDTO).call(this));
    _this.rePriceType = rePriceType;
    _this.priceListTypeId = priceListTypeId;
    _this.priceCodeId = priceCodeId;
    _this.currentYearRepricingCount = currentYearRepricingCount;
    _this.lastTenWeeksRepricingCount = lastTenWeeksRepricingCount;
    _this.currentWeekRepricingCount = currentWeekRepricingCount;
    _this.lastYearSameWeekRepricingCount = lastYearSameWeekRepricingCount;
    _this.nextWeekRepricingCount = nextWeekRepricingCount;
    return _this;
  }

  return PriceStickersReportDTO;
}(DomainObject_1.DomainObject);

exports.PriceStickersReportDTO = PriceStickersReportDTO;

PriceStickersReportDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceStickersReportDTO.name);
  return {
    rePriceType: builder.opt(builder.senum('rePriceType', ReleaseType_1.ReleaseType, CodebookLookupSequence_1.CodebookLookupSequence.ReleaseType)),
    priceListTypeId: builder.str('priceListTypeId'),
    priceCodeId: builder.opt(builder.str('priceCodeId')),
    currentYearRepricingCount: builder.num('currentYearRepricingCount'),
    lastTenWeeksRepricingCount: builder.num('lastTenWeeksRepricingCount'),
    currentWeekRepricingCount: builder.num('currentWeekRepricingCount'),
    lastYearSameWeekRepricingCount: builder.num('lastYearSameWeekRepricingCount'),
    nextWeekRepricingCount: builder.num('nextWeekRepricingCount')
  };
}();